import { routes } from './routes'
import { vsName as userProfileModuleName } from '../application/userProfileModule'

var mod = angular.module('SlotTrak.Machines.Progressives', ['records', userProfileModuleName])

mod
  .config(routes)

export default mod.name